import { AxiosResponseType } from '../../types/axiosTypes';
import api from '../axios';
import { fetchAuthSession } from '@aws-amplify/core';

export const updateSite = async (
  id: string,
  siteState: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/site/update-site`, {
      token: idToken,
      siteId: id,
      siteInfo: siteState,
    });
    return res.data;
  } else {
    throw new Error('Error updating site');
  }
};

export const updateSiteFormData = async (
  formData: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    // Assuming the backend handles updates at this endpoint
    // and expects the ID to be present within the FormData fields (e.g. inside siteInfo JSON)
    const res = await api.post<AxiosResponseType>(
      `/site/update-site`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: idToken,
        },
      }
    );
    return res.data;
  } else {
    throw new Error('Error updating site with files');
  }
};

export const createSiteFormData = async (
  formData: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(
      `/site/create-site`,
      formData, // Send FormData instead of JSON
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Required for file uploads
          Authorization: idToken,
        },
      }
    );
    return res.data;
  } else {
    throw new Error('Error creating site');
  }
};

export const createSite = async (
  siteState: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/site/create-site`, {
      token: idToken,
      siteInfo: siteState,
    });
    return res.data;
  } else {
    throw new Error('Error creating site');
  }
};

export const deleteSite = async (
  id: string
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    //used a post after all, since the delete didn't ut it
    const res = await api.post<AxiosResponseType>(`/site/delete-site`, {
      token: idToken,
      payload: id,
    });
    return res.data;
  } else {
    throw new Error('Error deleting site');
  }
};
